import React from "react"

type Props = {
  children: React.ReactNode
}

const HeadingText = ({ children }: Props) => {
  return (
    <span className="font-raleway-light font-light md:text-xs lg:text-sm xl:text-base 2xl:text-lg ml-1 cursor-pointer text-white">
      {children}
    </span>
  )
}

export default HeadingText
